import { useEffect, useMemo, useState, useSyncExternalStore } from 'react';
import { getEditorHostOrigin } from '../utils/editorCanvasHost';
const noopSubscribe = () => () => {};
const noSnapshot = () => undefined;
const noop = () => {};
let storeLoad;
let loadedStore;

// The editor messaging (interframe, ts-schema and the protocol) is code-split
// and only loaded in a page the editor frames, so visitors never download it.
// Every caller shares one store.
function loadCanvasStore(hostOrigin) {
  var _storeLoad;
  (_storeLoad = storeLoad) !== null && _storeLoad !== void 0 ? _storeLoad : storeLoad = import( /* webpackChunkName: "portals-editor-canvas" */'../utils/editorCanvas').then(({
    createEditorCanvasStore
  }) => {
    loadedStore = createEditorCanvasStore(hostOrigin, window.parent);
    return loadedStore;
  });
  return storeLoad;
}

/**
 * When this page is the page editor's canvas (framed by an allowed HubSpot
 * editor), the editor's state and the edits the canvas can send it.
 * Otherwise undefined, so the page renders as visitors see it.
 */
export function usePortalsEditorCanvas() {
  var _store$subscribe, _store$getSnapshot;
  const hostOrigin = getEditorHostOrigin();
  const [store, setStore] = useState(loadedStore);
  useEffect(() => {
    if (!hostOrigin || store) {
      return undefined;
    }
    let mounted = true;
    loadCanvasStore(hostOrigin).then(loaded => {
      if (mounted) {
        setStore(loaded);
      }
    }).catch(error => {
      console.error('[portals editor canvas] Failed to load', error);
    });
    return () => {
      mounted = false;
    };
  }, [hostOrigin, store]);
  const snapshot = useSyncExternalStore((_store$subscribe = store === null || store === void 0 ? void 0 : store.subscribe) !== null && _store$subscribe !== void 0 ? _store$subscribe : noopSubscribe, (_store$getSnapshot = store === null || store === void 0 ? void 0 : store.getSnapshot) !== null && _store$getSnapshot !== void 0 ? _store$getSnapshot : noSnapshot, noSnapshot);
  return useMemo(() => {
    var _store$select, _store$hover, _store$setField, _store$move, _store$selectLayout;
    if (!hostOrigin) {
      return undefined;
    }
    // Nothing can call these before the store loads: there's no snapshot yet,
    // so the canvas has nothing to click.
    return {
      snapshot,
      select: (_store$select = store === null || store === void 0 ? void 0 : store.select) !== null && _store$select !== void 0 ? _store$select : noop,
      hover: (_store$hover = store === null || store === void 0 ? void 0 : store.hover) !== null && _store$hover !== void 0 ? _store$hover : noop,
      setField: (_store$setField = store === null || store === void 0 ? void 0 : store.setField) !== null && _store$setField !== void 0 ? _store$setField : noop,
      move: (_store$move = store === null || store === void 0 ? void 0 : store.move) !== null && _store$move !== void 0 ? _store$move : noop,
      selectLayout: (_store$selectLayout = store === null || store === void 0 ? void 0 : store.selectLayout) !== null && _store$selectLayout !== void 0 ? _store$selectLayout : noop
    };
  }, [hostOrigin, store, snapshot]);
}